export function createStore(parameters) {
  return {
    namespaced: true,

    state: {
      lastAction: {
        added: null,
        removed: null,
        target: '',
      },
    },

    actions: {
      setRemovedId({ commit }, payload) {
        commit('SET_REMOVED_ID', payload)
      },

      setAddedId({ commit }, payload) {
        commit('SET_ADDED_ID', payload)
      },

      setTarget({ commit }, payload) {
        commit('SET_TARGET', payload)
      },
    },

    mutations: {
      SET_REMOVED_ID(state, payload) {
        state.lastAction.removed = payload
      },

      SET_ADDED_ID(state, payload) {
        state.lastAction.added = payload
      },

      SET_TARGET(state, payload) {
        state.lastAction.target = payload
      },
    },
  }
}
